import script from "./sale-analys-drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./sale-analys-drawer.vue?vue&type=script&setup=true&lang=js"

import "./sale-analys-drawer.vue?vue&type=style&index=0&id=5de41b84&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de41b84"]])

export default __exports__